module.exports = "https://static.wmbcdn.com/uniweb/images/5f91226992d4881c65a346ddb4186183.svg";